import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, message, Popconfirm, Popover, Space } from 'antd';
import React, { useState } from 'react';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import { useSelector } from 'react-redux';
import {
  deleteEligibilityPlan,
  getEligibilityPlans,
} from '../../network/eligibilityPlan';
import { queryKeys } from '../../services/react-query/queryKeys';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { ModalAppEligibilityPlan } from '../../components/upeosoft/ModalApp/ModalApp';
import { PlusOutlined } from '@ant-design/icons';

const EligibilityPlan = ({ t }) => {
  const client = useQueryClient();
  const { currentLang } = useSelector((state) => state.user);
  const [searchText, setSearchText] = useState('');
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getEligibilityPlans],
    queryFn: () => getEligibilityPlans(),
    keepPreviousData: true,
  });
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteEligibilityPlan(id),
      onSuccess: (data) => {
        // console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message);
          return false;
        }
        client.invalidateQueries({
          queryKey: [queryKeys.getEligibilityPlans],
        });
        message.success('Deleted successfully');
        // message.success('تم الحذف بنجاح');
      },
      onError: () => {
        message.error('حدث خطأ ما');
      },
    }
  );
  const columns = [
    {
      title: currentLang === 'en' ? 'Insurance Plan Name' : 'اسم خطة التأمين',
      dataIndex: 'insurance_plan_name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        return String(record.insurance_plan_name)
          .toLowerCase()
          .includes(value.toLowerCase());
      },
    },
    {
      title: currentLang === 'en' ? 'Insurance Payor' : 'مقدم التأمين',
      dataIndex: 'insurance_payor',
    },
    {
      title: currentLang === 'en' ? 'Price List' : 'قائمة الأسعار',
      dataIndex: 'price_list',
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 150,
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            <Popover
              placement="top"
              title={t.edit}
              onClick={() => {
                setEdit(true);
                setOpen(true);
                setEditId(record.name);
              }}
            >
              <Button
                size="small"
                type="primary"
                // onClick={() => navigate(`/patients/${record.uid}`)}
              >
                <MdModeEditOutline />
              </Button>
            </Popover>
            <Popconfirm
              title="Delete the Patient"
              description="Are you sure to delete this patient?"
              onConfirm={() => handleRemove.mutate(record.name)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => ({
    key: index,
    ...item,
  }));
  return (
    <div className="eligibility">
      <Heading title={t.Insurances} subTitle={t.eligibilityPlan} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        // titleBtn={t.addEligibilityPlan}
        Placeholder={t.searchEligibilityPlan}
        // pathBtn="/add-patient"
        buttonModal={
          <Button
            type="primary"
            onClick={() => {
              setOpen(true);
              setEdit(false);
            }}
          >
            <PlusOutlined
              style={{
                fontSize: '10px',
              }}
            />{' '}
            {t.addEligibilityPlan}
          </Button>
        }
      />
      <ModalAppEligibilityPlan
        t={t}
        open={open}
        setOpen={setOpen}
        edit={edit}
        record={editId}
      />
    </div>
  );
};

export default EligibilityPlan;
